
import { FramesManager } from 'shared-libs/components/view/frames-manager'

export const UI2_TEXT_DEFAULT_PROPS: Partial<UI2TextProps> = {
  variant: 'md',
  tone: 'dark',
}

/**
 * Semantic text style. Each value bundles size, weight, and (per-tone) color,
 * so platforms can align these with typical HTML tag hierarchy (`title`,
 * `h1`–`h4`) and their body/caption typography tokens.
 */
export type TextVariant =
  | 'title'
  | 'subtitle'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'lg'
  | 'md'
  | 'sm'
  | 'caption'

/**
 * Which color side of the variant to render.
 * - 'dark' → dark-colored text, for use on light backgrounds (the usual case).
 * - 'light' → light-colored text, for use on dark backgrounds.
 * Each `TextVariant` owns its own light and dark colors so the visual
 * hierarchy carries across both tones.
 */
export type TextTone = 'dark' | 'light'

export interface UI2TextProps {
  text?: string
  markdownText?: string
  /**
   * Semantic text style (e.g. title, h1–h4, body, caption). Defaults to 'md'.
   * Each platform maps these to its own font sizes, weights, and line heights.
   */
  variant?: TextVariant
  /**
   * Determines the color of the text. Defaults to 'dark' (for use on light backgrounds).
   * Arbitrary colors are intentionally not supported; prefer a ui2-banner component for semantic color messaging.
   * If more color options are needed, TextVariant should be extended with new variants that handle the color internally,
   * rather than exposing a free-form color prop.
   */
  tone?: TextTone
  translationTable?: Record<string, string>
  frames?: FramesManager
}
